import { createSlice } from '@reduxjs/toolkit'
import {
  updateOnSave,
  updateOnPublish,
} from 'apps/formsCreationKit/store/actions/sharedActions'
import { resetPdf } from 'apps/studio/store/actions/sharedActions'
import { actions as clientActions } from '@gocanvas/client'
const { loadFormData } = clientActions

export const initialState = {
  name: 'test',
  id: '',
  builderVersion: '3',
  in_builder_3_experience: false,
}

export const appSliceExtraReducers = builder => {
  builder
    .addCase(updateOnSave, (state, action) => {
      const { id, version, name } = action.payload
      return {
        ...state,
        id,
        version,
        name,
        status: 'pending',
      }
    })
    .addCase(updateOnPublish, state => {
      return {
        ...state,
        status: 'published',
      }
    })
    .addCase(loadFormData, (_, action) => {
      const { app } = action.payload
      return app
    })
    .addCase(resetPdf, (state, action) => {
      const { deletePdf } = action.payload
      const { defaultAppName, status } = state
      if (deletePdf && status === "new") {
        return {
          ...state,
          name: defaultAppName,
        }
      }
      return state
    })
}

export const appSliceConfig = {
  name: 'app',
  initialState: initialState,
  reducers: {
    updateName(state, action) {
      return {
        ...state,
        name: action.payload,
      }
    },
    // TODO: Is this still used/necessary? Remove if not
    updateBuilderVersion(state) {
      return {
        ...state,
        builderVersion: '2',
      }
    },
  },
  extraReducers: appSliceExtraReducers,
}

export const appSlice = createSlice(appSliceConfig)
export const { actions: appActions, reducer: appReducer } = appSlice
